module.exports = __webpack_public_path__ + "static/media/easterlywave.21380519.png";